var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaybycash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7516 16.8604V18.8904C10.7516 20.6104 9.15156 22.0004 7.18156 22.0004C5.21156 22.0004 3.60156 20.6104 3.60156 18.8904V16.8604C3.60156 18.5804 5.20156 19.8004 7.18156 19.8004C9.15156 19.8004 10.7516 18.5704 10.7516 16.8604Z",
    stroke: "#5599FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7498 14.1098C10.7498 14.6098 10.6098 15.0698 10.3698 15.4698C9.77984 16.4398 8.56984 17.0498 7.16984 17.0498C5.76984 17.0498 4.55984 16.4298 3.96984 15.4698C3.72984 15.0698 3.58984 14.6098 3.58984 14.1098C3.58984 13.2498 3.98984 12.4798 4.62984 11.9198C5.27984 11.3498 6.16984 11.0098 7.15984 11.0098C8.14984 11.0098 9.03984 11.3598 9.68984 11.9198C10.3498 12.4698 10.7498 13.2498 10.7498 14.1098Z",
    stroke: "#5599FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7516 14.1102V16.8602C10.7516 18.5802 9.15156 19.8002 7.18156 19.8002C5.21156 19.8002 3.60156 18.5702 3.60156 16.8602V14.1102C3.60156 12.3902 5.20156 11.0002 7.18156 11.0002C8.17156 11.0002 9.06156 11.3502 9.71156 11.9102C10.3516 12.4702 10.7516 13.2502 10.7516 14.1102ZM21.9996 10.9702V13.0302C21.9996 13.5802 21.5596 14.0302 20.9996 14.0502H19.0396C17.9596 14.0502 16.9696 13.2602 16.8796 12.1802C16.8196 11.5502 17.0596 10.9602 17.4796 10.5502C17.8496 10.1702 18.3596 9.9502 18.9196 9.9502H20.9996C21.5596 9.9702 21.9996 10.4202 21.9996 10.9702Z",
    stroke: "#5599FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.5V8.5C2 5.78 3.64 3.88 6.19 3.56C6.45 3.52 6.72 3.5 7 3.5H16C16.26 3.5 16.51 3.51 16.75 3.55C19.33 3.85 21 5.76 21 8.5V9.95H18.92C18.36 9.95 17.85 10.17 17.48 10.55C17.06 10.96 16.82 11.55 16.88 12.18C16.97 13.26 17.96 14.05 19.04 14.05H21V15.5C21 18.5 19 20.5 16 20.5H13.5",
    stroke: "#5599FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaybycash);
export default __webpack_public_path__ + "static/media/paybycash.e099c467fa2458e740b704c15edacaf2.svg";
export { ForwardRef as ReactComponent };